(() => {
  const manifest = document.getElementById('wrc-color-preload');
  if (!manifest || manifest.dataset.started) return;
  manifest.dataset.started = 'true';
  const params = new URLSearchParams(location.search);
  const connection = navigator.connection;
  const constrained = () => connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
  if (params.get('wrc_preload') === 'off' || constrained()) {
    manifest.dataset.status = 'disabled';
    return;
  }
  const galleryImage = () => Array.from(document.querySelectorAll('main media-gallery .product-media__image'))
    .find(image => image.getBoundingClientRect().width > 0);
  const main = galleryImage();
  if (!main) return;
  const identity = value => {
    const url = new URL(value, location.href);
    url.searchParams.delete('width');
    return url.href;
  };
  const seen = new Set([identity(main.currentSrc || main.src)]);
  const queue = Array.from(manifest.content.querySelectorAll('img')).filter(image => {
    const key = identity(image.src);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
  const retained = [];
  let loaded = 0;
  let started = false;
  let busy = false;
  let timer;
  manifest.dataset.queued = String(queue.length);
  const schedule = () => {
    clearTimeout(timer);
    if (!started || busy || document.hidden || constrained()) return;
    timer = setTimeout(next, 750);
  };
  const next = () => {
    if (document.hidden || constrained() || !manifest.isConnected) return;
    if (!queue.length) {
      manifest.dataset.status = 'complete';
      return;
    }
    const current = galleryImage();
    if (!current || !current.complete || !current.naturalWidth) {
      schedule();
      return;
    }
    const source = queue.shift();
    // A shopper may have selected this photo while the queue was waiting.
    if (identity(current.currentSrc || current.src) === identity(source.src)) {
      schedule();
      return;
    }
    busy = true;
    manifest.dataset.status = 'loading';
    const image = new Image();
    retained.push(image);
    image.fetchPriority = 'low';
    image.decoding = 'async';
    const finish = () => {
      image.onload = image.onerror = null;
      if (image.naturalWidth) loaded++;
      manifest.dataset.loaded = String(loaded);
      busy = false;
      schedule();
    };
    image.onload = finish;
    image.onerror = finish;
    image.sizes = current.sizes || '100vw';
    image.srcset = source.srcset;
    image.src = source.src;
  };
  const start = () => {
    if (started || !main.naturalWidth) return;
    started = true;
    manifest.dataset.status = 'waiting';
    schedule();
  };
  if (main.complete) start();
  else main.addEventListener('load', start, { once: true });
  document.addEventListener('visibilitychange', schedule);
  connection?.addEventListener('change', schedule);
  window.addEventListener('pagehide', () => clearTimeout(timer));
  window.addEventListener('pageshow', schedule);
})();
